type EventParams = Record<string, string | number | boolean | null | undefined>

export function trackEvent(eventName: string, params: EventParams = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  window.gtag('event', eventName, params)
}
